import { jsx, jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { Menu, X, ChevronDown, Sparkles } from "lucide-react";
const navLinks = ["Products", "Industries", "Solutions", "Case Studies", "Resources", "Pricing", "About"];
const calendlyUrl = "https://calendly.com/karan-kumar-orryworx";
function AINav() {
  const [scrolled, setScrolled] = useState(false);
  const [mobile, setMobile] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  useEffect(() => {
    if (!document.querySelector('link[href="https://assets.calendly.com/assets/external/widget.css"]')) {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = "https://assets.calendly.com/assets/external/widget.css";
      document.head.appendChild(link);
    }
    if (!document.querySelector('script[src="https://assets.calendly.com/assets/external/widget.js"]')) {
      const script = document.createElement("script");
      script.src = "https://assets.calendly.com/assets/external/widget.js";
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);
  const openCalendly = () => {
    setMobile(false);
    if (window.Calendly?.initPopupWidget) {
      window.Calendly.initPopupWidget({ url: calendlyUrl });
      return;
    }
    window.open(calendlyUrl, "_blank", "noopener,noreferrer");
  };
  return /* @__PURE__ */ jsxs(
    "nav",
    {
      className: "fixed top-0 left-0 right-0 z-50 transition-all duration-500",
      style: {
        backgroundColor: scrolled ? "rgba(255,255,255,0.92)" : "transparent",
        backdropFilter: scrolled ? "blur(20px)" : "none",
        borderBottom: scrolled ? "1px solid rgba(111,92,247,0.1)" : "1px solid transparent",
        boxShadow: scrolled ? "0 2px 32px rgba(111,92,247,0.06)" : "none"
      },
      children: [
        /* @__PURE__ */ jsxs("div", { className: "max-w-7xl mx-auto px-6 h-16 flex items-center justify-between", children: [
          /* @__PURE__ */ jsxs("a", { href: "#", className: "flex items-center gap-2.5", children: [
            /* @__PURE__ */ jsx(
              "div",
              {
                className: "w-8 h-8 rounded-xl flex items-center justify-center",
                style: { background: "linear-gradient(135deg,#6f5cf7 0%,#a855f7 100%)", boxShadow: "0 4px 12px rgba(111,92,247,0.35)" },
                children: /* @__PURE__ */ jsx(Sparkles, { size: 14, color: "white" })
              }
            ),
            /* @__PURE__ */ jsxs("span", { style: { fontFamily: "'Plus Jakarta Sans',sans-serif", fontWeight: 800, fontSize: "1.05rem", color: "#111827", letterSpacing: "-0.01em" }, children: [
              "Orryworx ",
              /* @__PURE__ */ jsx("span", { style: { color: "#6f5cf7" }, children: "AI" })
            ] })
          ] }),
          /* @__PURE__ */ jsx("div", { className: "hidden lg:flex items-center gap-7", children: navLinks.map((l) => /* @__PURE__ */ jsxs(
            "a",
            {
              href: "#",
              className: "flex items-center gap-0.5 text-sm font-medium transition-colors hover:text-primary",
              style: { fontFamily: "'Inter',sans-serif", color: "#374151" },
              children: [
                l,
                (l === "Products" || l === "Industries" || l === "Solutions") && /* @__PURE__ */ jsx(ChevronDown, { size: 12, style: { opacity: 0.5, marginLeft: 1 } })
              ]
            },
            l
          )) }),
          /* @__PURE__ */ jsxs("div", { className: "hidden lg:flex items-center gap-3", children: [
            /* @__PURE__ */ jsx(
              "button",
              {
                type: "button",
                className: "px-4 py-2 text-sm font-medium rounded-xl transition-all hover:bg-secondary",
                style: { fontFamily: "'Inter',sans-serif", color: "#374151" },
                children: "Talk to AI Expert"
              }
            ),
            /* @__PURE__ */ jsx(
              "button",
              {
                type: "button",
                onClick: openCalendly,
                className: "px-5 py-2.5 text-sm font-semibold rounded-xl transition-all duration-200 hover:scale-105 hover:shadow-lg",
                style: {
                  fontFamily: "'Plus Jakarta Sans',sans-serif",
                  background: "linear-gradient(135deg,#6f5cf7 0%,#8b5cf6 100%)",
                  color: "white",
                  boxShadow: "0 4px 16px rgba(111,92,247,0.35)"
                },
                children: "Book Demo"
              }
            )
          ] }),
          /* @__PURE__ */ jsx("button", { className: "lg:hidden p-2", style: { color: "#374151" }, onClick: () => setMobile(!mobile), children: mobile ? /* @__PURE__ */ jsx(X, { size: 20 }) : /* @__PURE__ */ jsx(Menu, { size: 20 }) })
        ] }),
        mobile && /* @__PURE__ */ jsxs(
          "div",
          {
            className: "lg:hidden border-t px-6 py-5 flex flex-col gap-4 bg-white",
            style: { borderColor: "rgba(111,92,247,0.08)" },
            children: [
              navLinks.map((l) => /* @__PURE__ */ jsx("a", { href: "#", className: "text-sm font-medium", style: { fontFamily: "'Inter',sans-serif", color: "#374151" }, children: l }, l)),
              /* @__PURE__ */ jsx(
                "button",
                {
                  type: "button",
                  onClick: openCalendly,
                  className: "mt-2 w-full py-3 text-sm font-semibold rounded-xl text-white",
                  style: { background: "linear-gradient(135deg,#6f5cf7,#8b5cf6)" },
                  children: "Book Demo"
                }
              )
            ]
          }
        )
      ]
    }
  );
}
export {
  AINav
};
